import { UnderlineNav } from '@primer/react';
import { isInternalExplorerEnabled } from '../../app/internal';
import { CoverageTabIcon, InstancesTabIcon, IssuesTabIcon, ReportTabIcon } from './RunTabIcons';
import styles from './run-tabs.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Minimal code-braces glyph for the internal Explorer tab. */
var ExplorerTabIcon = function ExplorerTabIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M5.5 3.5 2 8l3.5 4.5M10.5 3.5 14 8l-3.5 4.5",
      stroke: "currentColor",
      strokeWidth: "1.25",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

/**
 * The run-page tab bar — same primitive (@primer UnderlineNav) and same
 * ported icons as TMS's native test-run page, so the evidence view reads as
 * the same product. Controlled: the host of this component owns the active
 * tab (internal state in AppShell; a future ?tab= deep-link slots in there).
 * The palette's search trigger lives ABOVE this bar now: the standalone
 * TopBar (left of the .evidence download) or the TMS common header.
 */
export function RunTabs(_ref) {
  var active = _ref.active,
    onChange = _ref.onChange,
    instanceCount = _ref.instanceCount,
    _ref$issueCount = _ref.issueCount,
    issueCount = _ref$issueCount === void 0 ? 0 : _ref$issueCount;
  var select = function select(tab) {
    return function (event) {
      event.preventDefault();
      onChange(tab);
    };
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.bar,
    children: /*#__PURE__*/_jsxs(UnderlineNav, {
      "aria-label": "Test run views",
      children: [/*#__PURE__*/_jsx(UnderlineNav.Item, {
        icon: ReportTabIcon,
        "aria-current": active === 'report' ? 'page' : undefined,
        onSelect: select('report'),
        children: "Report"
      }), /*#__PURE__*/_jsx(UnderlineNav.Item, {
        icon: InstancesTabIcon,
        "aria-current": active === 'instances' ? 'page' : undefined,
        onSelect: select('instances'),
        counter: instanceCount,
        children: "Test Instances"
      }), /*#__PURE__*/_jsx(UnderlineNav.Item, {
        icon: IssuesTabIcon,
        "aria-current": active === 'issues' ? 'page' : undefined,
        onSelect: select('issues'),
        counter: issueCount > 0 ? issueCount : undefined,
        children: "Issues"
      }), /*#__PURE__*/_jsx(UnderlineNav.Item, {
        icon: CoverageTabIcon,
        "aria-current": active === 'coverage' ? 'page' : undefined,
        onSelect: select('coverage'),
        children: "Coverage"
      }), isInternalExplorerEnabled() && /*#__PURE__*/_jsx(UnderlineNav.Item, {
        icon: ExplorerTabIcon,
        "aria-current": active === 'explorer' ? 'page' : undefined,
        onSelect: select('explorer'),
        children: "Explorer"
      })]
    })
  });
}